import { DEFAULT_LANGUAGE } from '@nykaa/intl-shared/constants';
import { contentLang } from 'shared/constants';
import {
  filterTypes,
} from 'shared/constants/filterTypes';
import {
  ListingFilter,
} from 'shared/types/filters';


export const transformListingFilters = (data: any): ListingFilter[] => {
  if (!(data && Array.isArray(data))) {
    return [];
  }
  const transformedFilters: ListingFilter[] = [];
  data.forEach((filter) => {
    const filterData: any = {};
    const {
      key,
      type,
      facets,
      title,
      range,
      show_search_box: showSearch,
    } = filter;
    const { RANGE, SINGLE_SELECT, MULTI_SELECT, CATEGORY, COLOR } = filterTypes;
    // Range filter don't have facets
    const filtersWithoutFacets = [RANGE];
    if (type && key && title) {
      if (!filtersWithoutFacets.includes(key)) {
        filterData.data = facets;
      }
      filterData.key = key;
      filterData.title = title;
      filterData.showSearch = showSearch;
      if (filter[contentLang]) {
        filterData.contentLang = filter[contentLang][title] || DEFAULT_LANGUAGE;
      };
      switch (type) {
        case SINGLE_SELECT:
          filterData.type = SINGLE_SELECT;
          break;
        case MULTI_SELECT:
          filterData.type = MULTI_SELECT;
          break;
        case RANGE:
          filterData.type = RANGE;
          filterData.data = {
            min: Number(range?.min),
            max: Number(range?.max),
          };
          break;
        case CATEGORY:
          filterData.type = CATEGORY;
          break;
        case COLOR:
          filterData.type = COLOR;
          break;
        default:
          filterData.type = SINGLE_SELECT;
          break;
      }

      transformedFilters.push(filterData);
    }
  });
  return transformedFilters;
};

export const transformListingGuides = (data: any, filters: any[]): ListingFilter[] => {
  if (!(data && Array.isArray(data)) && (!(data && Array.isArray(data)))) {
    return [];
  }
  const transformedFilters: ListingFilter[] = [];
  data.forEach((filter) => {
    const filterData: any = {};
    const {
      type: filterKey,
      ...rest
    } = filter;

    if (filterKey ) {
      filterData.key = filterKey;
      filterData.data = rest;
    const type = filters.find(x => x.key === filterKey)?.type || '';
      switch (type) {
        case filterTypes.SINGLE_SELECT:
          filterData.type = filterTypes.SINGLE_SELECT;
          break;
        case filterTypes.MULTI_SELECT:
          filterData.type = filterTypes.MULTI_SELECT;
          break;
        case filterTypes.RANGE:
          filterData.type = filterTypes.RANGE;
          break;
        case filterTypes.CATEGORY:
          filterData.type = filterTypes.CATEGORY;
          break;
        case filterTypes.COLOR:
          filterData.type = filterTypes.COLOR;
          break;
        default:
          filterData.type = filterTypes.SINGLE_SELECT;
          break;
      }

      transformedFilters.push(filterData);
    }
  });

  return transformedFilters;
};
